import { httpClient, HttpMethod } from './http-client';
import { Tag } from '../@types/tag.type';

export interface CreateTagRequest {
  text?: string;
  colour?: string;
  isSystem?: boolean;
  entityTypeId?: number;
  entityId?: number;
  freshTags?: Tag[];
  existingTags?: Tag[];
}

export const createTag = (tag: CreateTagRequest): Promise<Tag> => {
  return httpClient<Tag>('/tags', HttpMethod.Post, tag);
};

export const getAllUserTags = (id: number): Promise<Tag[]> => {
  return httpClient<Tag[]>(`/tags/tagsByEntityType/${id}`, HttpMethod.Get);
};

export const getPartAllocatedTags = (): Promise<Tag[]> => {
  return httpClient<Tag[]>('/getPartAllocatedTags', HttpMethod.Get);
};
